import classes from "./index.module.scss";

export default function Card({ image, title, text }) {
  return (
    <div className={classes.card}>
      <div className={classes.card__image}>
        <img src={image?.src} alt={title} width={image.w} height={image.h} />
      </div>
      <p className={classes.card__text}>{text}</p>
    </div>
  );
}
